<template lang="pug">
  div
    slot(name="activator" :on="on")

    portal(to="modal" disabled)
      transition(name="modal")
        .modal(:class="setModifiers('modal--')" v-if="show")
          .modal__bg(@click="type === 'dialog' ? null : show = false")
          .modal__container(:style="computedWidth")
            .modal__close(:style="computedStyle.close" @click="show = false")
              span.icon-cross(style="font-size: 11px;")
            .modal__header.label-heading(v-if="this.$slots.header")
              slot(name="header")

            .modal__main( :style="computedStyle.main" )
              slot

            .modal__footer(v-if="this.$slots.footer")
              slot(name="footer")

          .modal__additional-container(v-if="this.$slots.addmain || this.$slots.addhead")
            .modal__additional-header(v-if="this.$slots.addhead")
              slot(name="addhead")

            .modal__additional-main(v-if="this.$slots.addmain")
              slot(name="addmain")
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'
import modalActivate from '@/mixins/modalActivate'

export default {
  mixins: [setClassModifiers, modalActivate],
  props: {
    /**
     * Sets fullwidth modifier if specified. If detects number, sets max-width in rems. 1rem = 10px.
     * @values full or Number
     */
    width: {
      type: [String, Number],
      default: 86
    },
    /**
     * Sets fullwidth modifier if specified. If detects number, sets max-width in rems. 1rem = 10px.
     * @values modal, dialog
     */
    type: {
      type: String,
      default: 'modal'
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    computedWidth () {
      if (typeof this.width === 'number') {
        return `max-width: ${this.width}rem;`
      }

      if (this.width === 'full') {
        return `width: 100%; margin: 0;`
      }

      return null
    },
    computedStyle () {
      let main
      let close

      if (this.$slots.header && !this.$slots.footer) {
        main = 'padding-bottom: 1.5rem'
      }

      if (!this.$slots.header && this.$slots.footer) {
        main = 'padding-top: 2rem'
      }

      if (!this.$slots.header && !this.$slots.footer) {
        main = 'padding: 2rem'
      }

      if (this.$slots.header) {
        close = 'top: 7px; right: 1.5rem;'
      }

      return {
        main,
        close
      }
    }
  },
  watch: {
    show (newVal) {
      // if (newVal === true) {
      //   this.$locker.lock('body', {
      //     reserveScrollBarGap: true
      //   })
      // } else {
      //   setTimeout(() => {
      //     this.$locker.unlockAll()
      //   }, 100)
      // }

      if (newVal === false) {
        this.$emit('input', 0)
      }

      if (newVal === true) {
        this.$emit('input', 1)
      }
    },
    value (newVal) {
      if (newVal === 0) {
        this.show = false
      } else {
        this.show = true
      }
    }
  }
}
</script>

<style lang="scss">
  .modal {
    background-color: rgba($color-black, .75);
    color: $color-black;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100vh;
    overflow: auto;
    z-index: 99999;

    &--full {
      align-items: stretch;

      .modal__container {
        margin: 0;
        border-radius: 0;
      }

      .modal__header, .modal__main, .modal__footer {
        max-width: 114rem;
        margin: 0 auto;
      }
    }

    &__bg {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      z-index: 99999;
    }

    &__container, &__additional-container {
      margin: 3rem;
      background-color: $color-white;
      position: relative;
      z-index: 999999;
      border-radius: $border-radius;
    }

    &__close {
      position: absolute;
      font-size: 1.4rem;
      color: $color-grey-dark;
      top: 1.5rem;
      right: 1.5rem;
      cursor: pointer;
    }

    &__header,
    &__main,
    &__footer,
    &__additional-header,
    &__additional-main
    {
      padding: .75rem 1.6rem;
    }

    &__footer {
      padding-top: 0;
      padding-bottom: 1rem;
    }

    &__header {
      padding: .75rem 1.6rem;
      border-bottom: 1px $color-grey-light solid;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;

      & > *:not(:last-child) {
        margin-right: 1rem;
      }
    }

    &__additional-container {

    }
  }

  .modal-enter-active {
    transition: all .1s;
  }

  .modal-leave-active {
    // transition: all .2s;
    transition: all .1s;
  }

  .modal-enter, .modal-leave-to {
    transform: translateY(-1rem);
    opacity: 0;
  }

  .modal--full.modal-enter, .modal--full.modal-leave-to {
    transform: translateY(1rem);
  }
</style>
